function forms () {
    const formContact = document.querySelectorAll('.form-contact');

    if(formContact.length > 0) {
        const input = document.querySelectorAll('.form-contact__input');

        //Добавляем всем инпутам с проверкой класс empty, чтобы при заполнении потом убрать
        input.forEach(el=> {
            if(el.dataset.validation) {
                el.classList.add('empty');
            }
        });


        /**
         * Проверка инпутов на соответствие валидации
         */
        function checkLength (input) {
            //Проверяем остальные все импуты кроме тех, что в условии на кол-во символов внутри
            if(input.dataset.validation && input.dataset.validation != 'tel') {
                //Берем из дата-атрибута количество минимальных символов
                const minimalLength = input.dataset.validation;

                if(input.value.length < minimalLength) {
                    input.classList.add('error');
                } else {
                    input.classList.remove('error');

                    if(input.classList.contains('empty'))
                        input.classList.remove('empty');
                }
            }

            //Проверяем инпут телефон на количество символов
            if(input.dataset.validation === 'tel') {
                if(input.value.length < 9) {
                    input.classList.add('error');
                } else {
                    input.classList.remove('error');
                    
                    if(input.classList.contains('empty'))
                        input.classList.remove('empty');
                }
            }
        }


        /**
         * Используем регулярное выражение для удаления всех символов
         * кроме цифр и "+" в телефоне
         */
        function checkPhone (input) {
            let cleanedValue = input.value.replace(/[^0-9+]/g, '');
            // Обновляем значение в поле ввода
            if(input.dataset.validation === 'tel') {
                input.value = cleanedValue;
            }
        }

        input.forEach(el=> {
            /**
             * Выполняем следующее при потере фокуса с инпута
             */
            el.addEventListener('blur', function() {
                checkLength (this);

                const parent = this.closest('.form-contact');
                const inputs = parent.querySelectorAll('.form-contact__input');

                //Создаем флаг для проверки
                let isEmpty = false;
        
                //Проходим по всем инпутам и если есть пустой инпут, меняем статус флага на true
                inputs.forEach( el => {
                    if(el.classList.contains('empty') || el.classList.contains('error')) isEmpty = true;
                });

                if(!isEmpty) {
                    const parent = this.closest('.form-contact');
                    const submit = parent.querySelector('.form-contact__submit');
                    submit.disabled = false;
                }
            });

            //Выполняем следующее при заполнении инпута
            el.addEventListener('input', function() {
                //Выполняем маску телефона
                checkPhone (this);
                //Выполняем валидацию
                checkLength (this);
            });
        });


        /**
         * Проверяем инпуты при клике на кнопку отправить
         */
        const submitBtn = document.querySelectorAll('.form-contact__submit');

        submitBtn.forEach(el=> {
            el.addEventListener('click', function(e) {
                const parent = this.closest('.form-contact');
                const inputs = parent.querySelectorAll('.form-contact__input');

                //Проходим по всем инпутам
                inputs.forEach(el=> {
                    //Если есть пустые инпуты добавляем им класс error
                    if(el.classList.contains('empty'))
                        el.classList.add('error');

                    //И проверяем на корректность заполненных данных
                    if(el.classList.contains('empty') || el.classList.contains('error')) {
                        this.disabled = true;
                    }
                });
            });
        });


        /**
         * Обработка формы при отправке
         */
        formContact.forEach(el=> {
            el.addEventListener('submit', function (e) {
                //Отключаем стандартное поведение формы
                e.preventDefault();

                //Получаем путь к скрипту отправки данных и отправляем запрос на сервер
                const action = this.getAttribute('action');
                const formData = new FormData(el);
                const request = new XMLHttpRequest();

                request.open('POST', action);
                request.send(formData);

                request.addEventListener('load', () => {
                    //Находим модалку с текстом оповещения об отправке формы и попап
                    const successModal = document.querySelector('.notice');
                    const popup = document.querySelector('.popup');

                    if (request.status === 200) {//При успешной отправке
                        //Очищаем форму
                        el.reset();

                        //Если форма была отправлена из всплывающего окна, закрываем его
                        if(popup.classList.contains('show')) 
                            popup.classList.remove('show');

                        //Показываем уведомление об успешной отправке
                        setTimeout(()=> successModal.classList.add('show'), 1000);
                    } else {//Если возникла какая-то ошибка
                        alert("Что-то пошло не так. Перезагрузите страницу и попробуйте еще раз");
                    }
                });
            });
        });
    }
}

export default forms;